import { Component, Input, OnInit, ChangeDetectorRef } from '@angular/core';

@Component({
  selector: 'fun-overview-bar',
  templateUrl: './overview-bar.component.html',
  styleUrls: ['./overview-bar.component.scss']
})
export class OverviewBarComponent implements OnInit {

  @Input() data: any;
  @Input() hiddePercent: boolean = false;
  @Input() hiddeObjetive: boolean = false;
  @Input() hiddeLegend: boolean = false;
  @Input() size: string = 'm';

  barWidth: number;
  barWidthReserved: number;
  percent: number;
  percentReserved: number;
  leftPercent: number;
  objetiveParse: string;
  minExceeded: boolean = false;
  total: number;
  minOfficialBarPosition: number = 0;

  constructor(private chdRef: ChangeDetectorRef) { }

  ngOnInit() {
    this.getData();
    this.chdRef.detectChanges();
  }

  getData() {
    this.minExceeded = this.data.min_exceeded;
    this.total = this.data.total_official && this.data.total_official > 0 && !this.minExceeded ? this.data.total_official : this.data.total;
    this.percent = (this.data.contributed / this.total) * 100;
    this.percentReserved = (this.data.reserved / this.total) * 100;
    this.leftPercent = this.percent <= 5 ? 6 : this.percent > 94 ? 90 : this.percent;
    this.barWidth = this.percent < 2.5 ? 2.5 : this.percent > 100 ? 100 : this.percent;
    this.barWidthReserved = this.percentReserved < 2.5 ? 2.5 : this.percentReserved > 100 ? 100 : this.percentReserved;
    this.objetiveParse = this.data.total_parse;
    if (this.minExceeded && this.data.total_official > 0) {
      this.minOfficialBarPosition = Math.min((this.data.total_official / this.data.total) * 100, 98);
    }
    this.chdRef.detectChanges();
  }

}
